<span class="visually-hidden" role="status">Loading…</span>

@switch (placeholderLayout()) {

	@case (formPlaceholderLayout.Advanced) {
		@for (row of advanced()?.rows; track $index) {
			<div [class]="row.classList" [class.d-flex]="row.columns?.length > 0"
				[class.shiny__loading__bg]="row.isShiny" [style.width]="row.width" [style.minWidth]="row.width"
				[style.height]="row.height" aria-hidden="true">
				@for (col of row.columns; track $index) {
					<div [class]="col.classList" [class.shiny__loading__bg]="col.isShiny" [style.width]="col.width"
						[style.minWidth]="col.width" [style.height]="col.height" aria-hidden="true">
						&nbsp;</div>
				} @empty {
					&nbsp;
				}
			</div>
		}
	}

	@default {
		<div class="char-data__group">
			<div class="char-data__group__element">
				<div class="shiny__loading__bg h-100 w-100">
					&nbsp;
				</div>
				<div>
					@for (row of rows(); track $index) {
						<div class="char-data__control container m-0">
							<div class="shiny__loading__bg w-100">
								&nbsp;
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	}
}